import Vue from 'vue'
import Vuex from 'vuex'
import http from './plugins/http'
import apiRoutes from './router/api-routes'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    status: ''
  },
  mutations: {
    auth_request (state) {

    },

    auth_success (state, user) {
    },
    auth_error (state) {
    },
    logout (state) {

    }
  },
  actions: {

  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    userinfo: state => state.user
  }
})
